import store from '@/store'
import router from '@/routes/'
import {API, PROJ_PFX} from '@/constants'

export interface AuthData {
  auth: string
  password: string
}

function isAuthenticated () {
  return readToken()
}

function readToken () {
  return localStorage.getItem(`${PROJ_PFX}token`)
}

function clearToken () {
  return localStorage.removeItem(`${PROJ_PFX}token`)
}

export function readRefreshToken () {
  return localStorage.getItem('refresh_token')
}

function setToken (token: string) {
  try {
    const almostHour = 1 * 55 * 60 * 1000; // 55 minutes
    localStorage.removeItem('token_live_until');
    localStorage.setItem('token_live_until', String(new Date().getTime() + almostHour));
    return localStorage.setItem(`${PROJ_PFX}token`, token)
  } catch (error) {
    throw error;
  }
}


let pathTo: string;

async function login (data: AuthData, newToken: string) {
  try {
    setToken(newToken);
    // setToken(window.btoa(`${data.auth}:${data.password}`));
    await store.dispatch('user/loadUser', true)
    return pathTo || '/';
  } catch (error) {
    clearToken()
    throw error;
  }
}

async function logout (logoutAll = false, otherTab = false) {
  store.commit('user/user', {})
  store.commit('preheaders/closeAll')
  clearToken()
  router.push({name: 'login'})
}

async function authLookup (auth: string) {
  /* try {
    let response = await store.dispatch('apiRequest', {method: API.admin.authLookup, data: {auth}})
    return response;
  } catch (error) {
    throw error;
  } */
}

function setPathTo (path: string) {
  pathTo = path
}

const api = {
  isAuthenticated,
  readToken,
  clearToken,
  setToken,
  login,
  logout,
  setPathTo,
  authLookup,
  readRefreshToken
}

export default api